import {BASE_PATH, PATH_BASE_EXTENSION_USER} from "../../utils/constants";
import {getToken} from "../Auth/token";
import axios from "axios";

const urlBase = `${BASE_PATH}${PATH_BASE_EXTENSION_USER}/organization`;

export async function getApiOrganizationSearch() {
    const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
    return axios.get(`${urlBase}/search`, config)
}

